function fn_comp_testdrive() {
    var $fn = $(".comp_testdrive");

    if($fn.length){
        $fn.find("#testdrive_datepicker").loadDatepicker();

        var $slider = $fn.find(".slider_front"),
            $wrp_datepicker = $fn.find(".wrp_datepicker");

        $slider.on('afterChange', function(slick, currentSlide) {
            $wrp_datepicker.addClass("mod--loading");
            console.log(); //id produktu
            $.ajax({
                method: 'get',
                url: window.location.href,
                data: {
                    modelId: $(currentSlide.$slides.eq(currentSlide.currentSlide)).data("product-id"),
                    chooseModel: true
                },
                dataType: 'json',
                success: function (payload) {
                    console.log(payload);
                    if (payload) {
                        if (payload.snippets) {
                            for (var i in payload.snippets) {
                                $("#" + i).replaceWith(payload.snippets[i]);
                            }
                        }
                    }
                    $fn.find("#testdrive_datepicker").loadDatepicker();
                    $wrp_datepicker.removeClass("mod--loading");
                }
            });
        });

        $(document).on('change','select[data-rental-days]', function() {

            var value = $(this).val();
            var priceElem = $('#rentalPrice');

            if(value) {
                priceElem.html(priceElem.attr('data-price-' + value) + ' ' + priceElem.attr('data-currency'));
            }


        });

    }
}
